import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
@Component({
    selector: 'app-download-icon-renderer',
    templateUrl: './downloadIconRenderer.component.html',
    standalone: false
})
export class DownloadIconRendererComponent implements ICellRendererAngularComp {
    public csvURL: string;

    constructor() {}

    agInit(params: ICellRendererParams): void {
        this.csvURL = params.value;
    }

    refresh(params: ICellRendererParams): boolean {
        this.csvURL = params.value;
        return true;
    }
    download() {
    window.open(this.csvURL, "_blank");
  }
}